import { FormGroup, FormControl } from '@angular/forms';
import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { Location } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICampaign } from '../../../../shared/models/campaign.model';
import { UtilService, CampaignService } from '../../../../shared/services';
import { StartAFrUrls } from 'src/app/shared/models/start-fr-urls';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  isDesktop = true;
  isHide = true;
  param;
  isPreview;
  previewSrc;
  isCampaignPage;
  draft: ICampaign;
  button = {
    image: false,
    advance: false,
    desc: false
  };
  type;
  languagePreview = {
    'English': {
      preview: 'Preview'
    },
    'Hindi': {
      preview: 'पूर्व दर्शन'
    },
    'Telugu': {
      preview: 'ప్రివ్యూ'
    },
    'Tamil': {
      preview: 'முன்னோட்டம்'
    }
  };
  currentLanguage: any;
  @Input('campaignType') campaignType?;
  @Output() onLangChange = new EventEmitter<any>();

  languageForm: FormGroup;
  language: FormControl;
  islanguageSelected: any;
  languages = [
    { label: 'हिंदी', value: 'Hindi', preview: 'पूर्व दर्शन' },
    { label: 'English', value: 'English', preview: 'Preview' },
    { label: 'తెలుగు', value: 'Telugu', preview: 'ప్రివ్యూ' },
    { label: 'தமிழ்', value: 'Tamil', preview: 'முன்னோட்டம்' },
  ];

  startAFrUrls = StartAFrUrls;

  constructor(
    private actRoute: ActivatedRoute,
    private util: UtilService,
    private location: Location,
    private campaignService: CampaignService,
    private vars: VariablesService
  ) { }

  ngOnInit() {
    this.currentLanguage = this.util.storage.get('language') || 'English';
    this.islanguageSelected = Boolean(this.util.storage.getFromSession('isLanguageSelected')) || false;
    this.checkDevice();
    this.getParams();
    this.getUrl();
    this.getDraft();
    this.initLanguageForm();
  }

  private initLanguageForm() {
    this.languageForm = new FormGroup({
      language: this.language = new FormControl(this.currentLanguage)
    });
  }

  /**
   * Get the URL params
   */
  getParams() {
    this.util.param$.subscribe(res => {
      this.param = res;
    });
    if (!this.param) {
      this.actRoute.params.subscribe((param) => {
        this.param = param['id'];
      });
    }
  }
  setButtonActive(form) {
    return this.param === form ? 'active' : '';
  }
  getUrl() {
    this.util.url$.subscribe((res: any) => {
      if (res) {
        this.isHide = this.hide(res.url);
        this.isPreview = this.preview(res.url);
        // this.isPreviewOpen = res.url.split('/')[2];
        this.isCampaignPage = res.url.includes('new/crowdfunding') ? true : false;
      }
    });
  }
  /**
   * Get draft details
   */
  getDraft() {
    this.vars.draftObs.subscribe((res) => {
      this.draft = res;
      this.disableCheck();
    });
  }
  /**Set the form */
  setForm(param) {
    this.type = this.actRoute.snapshot.queryParams['type'];
    if (this.draft) {
      if (!this.campaignType || this.campaignType !== 'medical') {
        this.util.navigateToForm(param, this.type, this.draft.id);
      } else {
        this.util.navigateToMedicalForm(param, this.type, this.draft.id);
      }
    }
  }
  /**form disbale or not  */
  disableCheck() {
    this.button.image = this.draft?.id ? false : true;
    this.button.advance = this.draft?.media?.length ? false : true;
    this.button.desc = (this.campaignType && this.campaignType === 'medical') ?
      (this.draft?.disease ? false : true) :
      (this.draft?.address_1 || this.draft?.address_2 || this.draft?.address_3 ? false : true);
  }
  /**
   * back navigation
   */
  back() {
    this.location.back();
  }
  preview(url) {
    const name: string = url.split('?')[0].split('/').reverse()[0];
    return name.match('desc|reward') ? true : false;
  }
  /**
   * Hide functionality on basis of responsiveness
   */
  hide(url: string) {
    const name = url.split('?')[0].split('/').reverse()[0];
    return false;
    // switch (true) {
    //   case this.isDesktop:
    //     return false;
    //   case name === '':
    //     return false;
    //   case name === 'basic':
    //     return false;
    //   default:
    //     return true;
    // }
  }
  /**Show preview */
  showPreview() {
    if (this.param === 'desc' && this.draft?.about) {
      /**On change api hit */
      const desc = this.draft.about.info_1;
      if (desc && desc.length >= 50) {
        const payload = {
          'about': {
            'entity_type': 'campaign',
            'info_1': desc,
            'info_type': 'social'
          },
        };
        this.campaignService.updateCampaign(payload, this.draft.id).subscribe((res: any) => {
          this.draft.about = res.data.about;
          this.vars.draftObs.next(this.draft);
        });
      }
    }
    const campaignType = this.campaignType && this.campaignType === 'medical' ? 'medical' : 'non-medical';
    this.util.navigate(`${this.startAFrUrls[campaignType]}/preview`, this.draft?.id?.toString());
  }
  /**Check Device to manage the
   * resposive functionality better
   */
  checkDevice() {
    this.isDesktop = !this.util.isMobile();
  }

  selectLanguage(event) {
    this.islanguageSelected = true;
    this.changeLanguage(event);
  }

  changeLanguage(language) {
    this.currentLanguage = language;
    this.util.storage.check('language', this.currentLanguage);
    this.util.storage.addSessionData('isLanguageSelected', this.islanguageSelected);
    this.onLangChange.emit(this.currentLanguage);
  }

}
